 
  <div class="row">  
    <div class="col-md-12 col-sm-6">
      <app-activity-feed [history]="history" ></app-activity-feed>
    </div>
  </div> 
